const moment = require('moment')

 module.exports =  function uniqueId (){
    let date = moment().date() 
                    let month = moment().month()
                    let hour = moment().hour()
                    let min  = moment().minutes()
                    let sec =  moment().seconds()  

                    let timeStamp = date + '-'+month+ ':'+ hour+':'+ min+ ':' +sec
                    let randomNumbers = Math.floor(Math.random() * 1000000000000000000);
                    let someText =  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                    let finalId = timeStamp+':'+randomNumbers+ ':'+someText
                    
                    return  finalId
}
